import { defineComponent as _defineComponent } from 'vue'
import CardExpand from '@/views/components/CardExpand.vue';
import { mdiDelete, mdiInformation, mdiPlusCircleOutline } from '@mdi/js';
import AutocompleteGraphql from '@/views/components/autocompletes/AutocompleteGraphql.vue';
import { GET_FONTE, GET_ORGAO_EXPEDITOR, GET_TIPO_NORMA } from '@/queries';
import { ConsultaLegislacaoStore } from '@/views/legislacao/store/ConsultaLegislacaoStore';
import { storeToRefs } from 'pinia';
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router/composables';
import { mdiChevronDown, mdiChevronUp } from '@mdi/js';

import { useLazyQuery } from '@vue/apollo-composable';


export default /*#__PURE__*/_defineComponent({
  __name: 'CardMaisFiltros',
  setup(__props) {

const { query } = useRoute();
const updateCount = ref(0);
const showLegislativasNormativas = ref(false);

onMounted(() => {
  const expandirPesquisaAvancada = Boolean(Object.keys(query).length);
  filtroLegislacao.value.expandirPesquisaAvancada = expandirPesquisaAvancada;
  setOrgaoExpeditorByUrl();
  setTipoNormaByUrl();
});

const store = ConsultaLegislacaoStore();
const { filtroLegislacao } = storeToRefs(store);

const setOrgaoExpeditorByUrl = async () => {
  if (!query.deOrgaoexpedidor) return;

  const descricao = `${query.deOrgaoexpedidor}`.replace(/^"(.*)"$/, '$1');
  const request = useLazyQuery(GET_ORGAO_EXPEDITOR);
  request.variables.value = { nmOrgaoExpedidor: descricao };
  await request.load();
  const responseOrgaoExpeditor = { value: request.result.value, descricao };
  if (responseOrgaoExpeditor?.value) {
    updateCount.value++;
    filtroLegislacao.value.orgaoExpedidorSelected = [
      responseOrgaoExpeditor.value.orgaosExpedidores.find(
        (res: { nmOrgaoExpedidor: string }) =>
          res.nmOrgaoExpedidor == responseOrgaoExpeditor.descricao
      ),
    ];
  }
};

const setTipoNormaByUrl = async () => {
  if (!query.deTiponorma) return;

  const descricao = `${query.deTiponorma}`.replace(/^"(.*)"$/, '$1');
  const request = useLazyQuery(GET_TIPO_NORMA);
  request.variables.value = { deTipoNorma: descricao };
  await request.load();
  const responseTipoNorma = { value: request.result.value, descricao };
  if (responseTipoNorma?.value) {
    updateCount.value++;
    filtroLegislacao.value.tipoNormaSelected = [
      responseTipoNorma?.value.tipoNormas.find(
        (res: { deTipoNorma: string }) =>
          res.deTipoNorma == responseTipoNorma.descricao
      ),
    ];
  }
};

return { __sfc: true,query, updateCount, showLegislativasNormativas, store, filtroLegislacao, setOrgaoExpeditorByUrl, setTipoNormaByUrl, CardExpand, mdiDelete, mdiInformation, mdiPlusCircleOutline, AutocompleteGraphql, GET_FONTE, GET_ORGAO_EXPEDITOR, GET_TIPO_NORMA, mdiChevronDown, mdiChevronUp }
}

})